module.exports = __webpack_public_path__ + "static/media/U1-T2-2-5.5a4a8ec0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-2-5.mp3
// module id = 565
// module chunks = 0